export default __webpack_public_path__ + "static/media/banner.e7002283.svg";